import { render, staticRenderFns } from "./CommonAvatar.vue?vue&type=template&id=2df631d3&scoped=true&"
import script from "./CommonAvatar.vue?vue&type=script&lang=ts&"
export * from "./CommonAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./CommonAvatar.vue?vue&type=style&index=0&id=2df631d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df631d3",
  null
  
)

export default component.exports